<h2 mat-dialog-title>Pacchetti aggiuntivi</h2>

@if (generalita) {
  <div class="generalita">{{ generalita }}</div>
}

<div mat-dialog-content class="dialog-center-cont">
  <app-lista-tabellare
    #tabella
    [fnCaricamentoDati]="fnCaricamentoDati"
    [colonne]="colonne"
    [isFiltri]="false"
    [defaultPageSize]="10"
  >
  </app-lista-tabellare>
</div>

<div mat-dialog-actions class="dialog-footer-cont">
  <div>
    <button mat-dialog-close mat-flat-button color="accent" class="accent-button">Chiudi</button>
  </div>
</div>
